import {config as numberColumnConfig} from '../../common/NumberColumn';

export const prop = 'cTNotSent';

export const config = (labels) =>
	numberColumnConfig({
		id: 'gaNotSent',
		label: labels.groupAuditNotSent,
		prop,
		width: 'minmax(var(--px-130), 1fr)'
	});
